// @flow
export const filterId: 'subsidy' = 'subsidy';
